import createAjax from '@/utils/createAjax';
var ajax = createAjax({
  errorHandler: function errorHandler() {// return router.replace('/error/网络出错');
  },
  baseURL: "".concat(PROJECT_ENV.BASE_API)
});
export default ajax;